<template>
  <div>
    <CardToggle
      logo="varnish"
      :label="$t('global.varnish-caching')"
      :description="$t('global.varnish-description')"
      class="pb-4"
    >
      <template #toggle>
        <Toggle
          v-model="enabled"
          @change="onToggle"
          :transitioning="isUpdating()"
          :disabled="!status.isLoaded"
        />
      </template>
    </CardToggle>
    <p>
      <i>{{ $t("global.varnish-compatibility-note") }}</i>
    </p>
    <CardListContent :list="list" />
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import CardListContent from "@/components/display/card-sub-components/CardListContent";
import CardToggle from "@/components/display/card-sub-components/CardToggle";
import store from "@/store";
import Toggle from "@/components/display/Toggle";

export default {
  name: "VarnishCaching",
  components: {
    CardListContent,
    CardToggle,
    Toggle,
  },
  props: {
    plan: {
      type: Object,
      required: true,
    },
    site: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const enabled = computed(() =>
      varnish.value ? ["creating", "stable"].includes(varnish.value.state) : false
    );
    const isUpdating = () =>
      (varnish.value ? ["creating", "destroying"].includes(varnish.value.state) : false) ||
      status.value.isLoading ||
      status.value.isUpdating;
    const list = computed(() => {
      if (varnish.value?.state !== "stable") return [];
      const list = [
        {
          label: root.$t("global.version"),
          content: varnish.value.version,
        },
      ];
      if (varnish.value.ports.length > 0) {
        list.push(
          {
            label: root.$t("global.backend-host"),
            content: varnish.value.hostname,
            canCopy: true,
          },
          {
            label: root.$t("global.backend-port"),
            content: varnish.value.ports[0].publishPort,
            canCopy: true,
          }
        );
      }
      return list;
    });
    const onToggle = (enabled) => {
      const dispatchType = enabled ? "containers/add" : "containers/delete";
      const data = enabled ? { type: "varnish" } : { groupId: varnish.value.id };
      store
        .dispatch(dispatchType, { id: props.site.id, data })
        .then(() => {
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: root.$t("toasts.varnish-changing-message", {
              name: props.plan.isTShirt ? props.plan.nickname : site.domain,
              action: root.$t(enabled ? "global.enabled" : "global.disabled").toLowerCase(),
            }),
          });
        })
        .catch(() => {
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.varnish-change-error-message", {
              name: props.plan.isTShirt ? props.plan.nickname : site.domain,
              action: root.$t(enabled ? "global.enable" : "global.disable").toLowerCase(),
            }),
          });
        });
    };
    const status = computed(() => store.getters["containers/getListStatus"]);
    const varnish = computed(() => store.getters["containers/getVarnish"]);

    onMounted(() => {
      store.dispatch("containers/getList", props.site.id);
    });

    return {
      enabled,
      isUpdating,
      list,
      onToggle,
      status,
      varnish,
    };
  },
};
</script>
